<template>
  <div class="modal" :class="{ nobackdrop: !backdrop }">
    <transition name="modal" @after-leave="finish" appear>
      <div v-if="show" class="dialog">
        <div class="title-area">{{ message }}</div>
        <div :class="{ 'btn-area': isMessage, 'btn-area-2col': isConfirm }">
          <span v-if="isMessage || isConfirm" @click="onClickOk">
            <template v-if="isMessage">OK</template>
            <template v-else>はい</template>
          </span>
          <span v-if="isConfirm" @click="onClickCancel">いいえ</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { DIALOG_TYPE } from "@/constants/constants";
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      required: true,
    },
    callbackOk: {
      type: Function,
    },
    callbackCancel: {
      type: Function,
    },
    backdrop: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      show: true,
      callbackFunc: null,
    };
  },

  computed: {
    isMessage() {
      return this.type === DIALOG_TYPE.MESSAGE;
    },
    isConfirm() {
      return this.type === DIALOG_TYPE.CONFIRM;
    },
  },

  methods: {
    onClickOk() {
      this.show = false;
      this.callbackFunc = this.callbackOk;
    },
    onClickCancel() {
      this.show = false;
      this.callbackFunc = this.callbackCancel;
    },
    finish() {
      this.$emit("finishDialog");

      if (this.callbackFunc) {
        this.$nextTick(this.callbackFunc);
      }
    },
  },
};
</script>

<style lang="scss">
.modal-enter-active,
.modal-leave-active {
  transition: all 0.2s ease;
}
.modal-enter,
.modal-leave-to {
  transform: scale(0.8);
  opacity: 0;
}
.modal-enter-to,
.modal-leave {
  transform: scale(1);
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9998;

  &.nobackdrop {
    background: inherit;
  }

  .dialog {
    font-size: 15px;
    display: block;
    width: 400px;
    box-sizing: border-box;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);

    .mobile & {
      width: 80%;
      max-width: 400px;
    }

    .title-area {
      text-align: center;
      padding: 20px;
      color: var(--purple);
      white-space: pre-line;
    }

    .error {
      color: red;
    }
    .error::before {
      content: " ";
      background: url("~@/assets/icons/ic_error.svg") no-repeat center center;
      background-size: 30px 30px;
      padding: 20px;
    }

    .btn-area {
      display: block;
      border-radius: 0 0 20px 20px;
      cursor: pointer;
    }

    .btn-area span {
      display: block;
      font-weight: bold;
      border-top: solid 1px #ddd;
      text-align: center;
      font-size: 15px;
      padding: 20px;
      border-radius: 0 0 20px 20px;
      color: var(--purple);
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
    }

    .btn-area span:hover {
      background: var(--purple-tertiary);
    }

    .btn-area span:active {
      background: var(--purple);
      color: #fff;
    }

    .btn-area-2col {
      display: flex;
      justify-content: space-between;
      border-radius: 0 0 20px 20px;
      cursor: pointer;
    }

    .btn-area-2col span {
      width: 50%;
      display: block;
      font-weight: bold;
      border-top: solid 1px #ddd;
      text-align: center;
      font-size: 15px;
      padding: 20px;
      color: var(--purple);
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
    }

    .btn-area-2col span:first-child {
      border-right: solid 1px #ddd;
      border-radius: 0 0 0 20px;
    }
    .btn-area-2col span:last-child {
      font-weight: normal;
      border-radius: 0 0 20px 0;
    }

    .btn-area-2col span:hover {
      background: var(--purple-tertiary);
    }

    .btn-area-2col span:active {
      background: var(--purple);
      color: #fff;
    }
  }
}
</style>
